import styled from 'styled-components';
import { Styling } from '../../../../constants';

const labelWidth = 70;
const labelRightMargin = Styling.DEFAULT_SPACING;
const valueRowHeight = 48;

export const ControlContainer = styled.div`
  align-items: center;
  display: flex;
  margin: ${Styling.DEFAULT_SPACING}px 0 ${Styling.DEFAULT_SPACING_HALVED}px;
  padding: 0 ${Styling.DEFAULT_SPACING_DOUBLED}px;
`;

export const Label = styled.div`
  margin-right: ${labelRightMargin}px;
  text-align: center;
  width: ${labelWidth}px;
`;

export const SupportNumber = styled.span`
  color: rgb(218,23,23);
  margin-left: 109px;
  margin-top: 20px;
  font-weight: 500
`;
